import React from "react";
import { useTranslation } from "react-i18next";
import { TestResultSearch } from "./tabs/TestResultSearch";
import { TestResultItemSearch } from "./tabs/TestResultItemSearch";
import { TestResultWideSearch } from "./tabs/TestResultWideSearch";
import style from "./dataSearch.module.scss";

export enum DataSearchTab {
  TEST_RESULT = "TEST_RESULT",
  TEST_RESULT_ITEM = "TEST_RESULT_ITEM",
  TEST_RESULT_WIDE = "TEST_RESULT_WIDE",
}

interface Props {
  activeTab: DataSearchTab;
  setActiveTab: (_: DataSearchTab) => void;
}

export function DataSearch({ activeTab, setActiveTab }: Props) {
  const { t } = useTranslation("dataSearch");

  return (
    <>
      <div className={style.tabWrapper}>
        <button
          className={`${style.tabButton} ${activeTab === DataSearchTab.TEST_RESULT ? style.active : ""}`}
          onClick={() => setActiveTab(DataSearchTab.TEST_RESULT)}
        >
          {t("tabs.testResult")}
        </button>
        <button
          className={`${style.tabButton} ${activeTab === DataSearchTab.TEST_RESULT_ITEM ? style.active : ""}`}
          onClick={() => setActiveTab(DataSearchTab.TEST_RESULT_ITEM)}
        >
          {t("tabs.testResultItem")}
        </button>
        <button
          className={`${style.tabButton} ${activeTab === DataSearchTab.TEST_RESULT_WIDE ? style.active : ""}`}
          onClick={() => setActiveTab(DataSearchTab.TEST_RESULT_WIDE)}
        >
          {t("tabs.testResultWide")}
        </button>
      </div>

      {activeTab === DataSearchTab.TEST_RESULT && <TestResultSearch />}
      {activeTab === DataSearchTab.TEST_RESULT_ITEM && <TestResultItemSearch />}
      {activeTab === DataSearchTab.TEST_RESULT_WIDE && <TestResultWideSearch />}
    </>
  );
}
